<h4>Additional Questions</h4>
<table  formArrayName="additional_answers">
  <tbody>
  <ng-container *ngFor="let d of additionalAnswersArray.controls; let i = index" [formGroupName]="i" >
    <tr><td class="td-first">{{d.get('question')?.value}}</td></tr>
    <tr>
      <td>
        <div class="k-form-field d-flex flex-column w-25 align-items-center" *ngIf="d.get('response_type')?.value == responseTypes[1]">
          <input type="number" [id]="'additional_number' + i"
                 [formControl]="getAnswerControl(d, 'value')" class="form-control" min="0" [step]="getStep(d)" style="text-align: center">
          <div *ngIf="getAnswerControl(d, 'value')?.invalid" class="alert alert-danger custom-alert">
            <div *ngIf="getAnswerControl(d, 'value')?.errors?.['required']">It's required</div>
            <div *ngIf="getAnswerControl(d, 'value')?.errors?.['min'] || getAnswerControl(d, 'value')?.errors?.['pattern']">
              Only positive numbers
              <ng-container *ngIf="d.get('decimal_places')?.value > 0; else noDecimals">
                up to {{ d.get('decimal_places')?.value }} decimals
              </ng-container>
              allowed.
            </div>
            <ng-template #noDecimals></ng-template>
          </div>
        </div>

        <div class="k-form-field d-flex flex-column w-100" *ngIf="d.get('response_type')?.value == responseTypes[0]">
          <textarea class="form-control" [id]="'additional_text' + i"
                    [formControl]="getAnswerControl(d, 'value')" rows="4"  style="width:100%;"></textarea >
          <div *ngIf="getAnswerControl(d, 'value')?.invalid" class="alert alert-danger custom-alert">
            <div *ngIf="getAnswerControl(d, 'value')?.errors?.['required']">It's required</div>
          </div>
        </div>

        <div class="k-form-field d-flex flex-column w-100" *ngIf="d.get('response_type')?.value == responseTypes[2]">
          <div *ngFor="let o of getOptions(d); let j = index">
            <label class="k-radio-label mb-1">
              <input type="radio" kendoRadioButton style="margin-top: 3px"
                     [id]="'additional_radio' + i + '_' + j"
                     [name]="'additional_radio' + i"
                     [formControl]="getAnswerControl(d, 'value')"
                     [value]="o.option"/>{{ o.option }}</label>
          </div>
          <div *ngIf="getAnswerControl(d, 'value')?.invalid" class="alert alert-danger custom-alert">
            <div *ngIf="getAnswerControl(d, 'value')?.errors?.['required']">It's required</div>
          </div>
        </div>

        <div class="k-form-field d-flex flex-column w-100" *ngIf="d.get('response_type')?.value == responseTypes[3]">
          <div *ngFor="let o of getOptions(d); let j = index">
            <label class="k-checkbox-label mb-0">{{ o.option }}</label>
            <input
              type="checkbox"
              kendoCheckBox
              [id]="'additional_checkbox'  + i + '_' + j"
              [checked]="isChecked(d, j)"
              [disabled]="getAnswerControl(d, 'value')?.disabled"
              (change)="toggleCheckbox(d, j, $event.target.checked)"
              style="margin-left: 6px"
            />
          </div>
          <div *ngIf="d.errors?.['requiredSelection']" class="alert alert-danger custom-alert">At Least one selection is required</div>
<!--          <div *ngIf="isRequiredInvalid(d)" class="alert alert-danger custom-alert">At Least one selection is required</div>-->
        </div>

      </td>
    </tr>
  </ng-container>


  </tbody>
</table>
